const enum Roles {
    SupportUserId = 1,
    AdminId = 2,
    SuperAdminId = 3,
}

export default Roles;
